/* Predictive Search for keelanscott.co
 * Uses Shopify native /search/suggest.json. Debounced, keyboard-navigable, mobile-first.
 */
(function () {
  var SEARCH_URL = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
  var DEBOUNCE_MS = 300;

  function money(cents) {
    // Simple USD formatter; site is USD.
    var n = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return '$' + n;
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function init(root) {
    var input = root.querySelector('[data-predictive-input]');
    var panel = root.querySelector('[data-predictive-panel]');
    var resultsBox = root.querySelector('[data-predictive-results]');
    var popularBox = root.querySelector('[data-predictive-popular]');
    if (!input || !panel || !resultsBox) return;

    var bestSellers = [];
    try {
      var bsEl = root.querySelector('[data-predictive-bestsellers]');
      if (bsEl) bestSellers = JSON.parse(bsEl.textContent || '[]');
    } catch (e) { bestSellers = []; }

    var timer = null;
    var activeIndex = -1;
    var lastQuery = '';

    function openPanel() { panel.hidden = false; input.setAttribute('aria-expanded', 'true'); }
    function closePanel() {
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      activeIndex = -1;
    }

    function showPopular() {
      if (popularBox) popularBox.hidden = false;
      resultsBox.innerHTML = '';
      resultsBox.hidden = true;
      openPanel();
    }

    function productRow(p, idx) {
      var img = p.image
        ? '<img class="predictive__thumb" src="' + escapeHtml(p.image) + '" alt="" width="56" height="56" loading="lazy">'
        : '<span class="predictive__thumb predictive__thumb--placeholder"></span>';
      var price = (p.price != null) ? '<span class="predictive__price">' + escapeHtml(p.price) + '</span>' : '';
      return '<a class="predictive__item" role="option" id="predictive-opt-' + idx + '" href="' + escapeHtml(p.url) + '">' +
        img +
        '<span class="predictive__item-text"><span class="predictive__item-title">' + escapeHtml(p.title) + '</span>' + price + '</span>' +
        '</a>';
    }

    function renderResults(products, query) {
      if (popularBox) popularBox.hidden = true;
      resultsBox.hidden = false;
      activeIndex = -1;

      if (products && products.length) {
        var rows = products.map(productRow).join('');
        var viewAll = '<a class="predictive__view-all" href="/search?q=' + encodeURIComponent(query) + '&type=product">' +
          'View all results for "' + escapeHtml(query) + '"</a>';
        resultsBox.innerHTML = '<div class="predictive__group-label">Products</div>' + rows + viewAll;
      } else {
        // Smart no-results: suggest best sellers instead of a dead end.
        var bsHtml = '';
        if (bestSellers.length) {
          bsHtml = '<div class="predictive__group-label">You might like</div>' +
            bestSellers.slice(0, 4).map(productRow).join('');
        }
        resultsBox.innerHTML =
          '<div class="predictive__empty">No matches for "' + escapeHtml(query) + '". Try a popular search or browse our best sellers.</div>' +
          bsHtml +
          '<a class="predictive__view-all" href="/collections/all">Browse all products</a>';
      }
      openPanel();
    }

    function fetchResults(query) {
      var url = SEARCH_URL + '?q=' + encodeURIComponent(query) +
        '&resources[type]=product&resources[limit]=6&section_id=predictive-search';
      // Prefer JSON API for structured data.
      var jsonUrl = SEARCH_URL + '.json?q=' + encodeURIComponent(query) +
        '&resources[type]=product&resources[limit]=6';
      fetch(jsonUrl, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (query !== lastQuery) return; // stale
          var items = ((data.resources || {}).results || {}).products || [];
          var mapped = items.map(function (p) {
            var priceStr = null;
            if (p.price != null && p.price !== '') {
              var cents = parseInt(String(p.price).replace(/[^0-9]/g, ''), 10);
              priceStr = isNaN(cents) ? null : money(cents);
            }
            var img = (p.featured_image && p.featured_image.url) ? p.featured_image.url : (p.image || null);
            return { title: p.title, url: p.url, image: img, price: priceStr };
          });
          renderResults(mapped, query);
        })
        .catch(function () {
          if (query === lastQuery) renderResults([], query);
        });
    }

    function onInput() {
      var q = input.value.trim();
      lastQuery = q;
      if (timer) clearTimeout(timer);
      if (!q) { showPopular(); return; }
      timer = setTimeout(function () { fetchResults(q); }, DEBOUNCE_MS);
    }

    function items() { return Array.prototype.slice.call(panel.querySelectorAll('.predictive__item, .predictive__chip, .predictive__view-all')); }

    function setActive(idx) {
      var list = items();
      list.forEach(function (el, i) {
        el.classList.toggle('is-active', i === idx);
        if (i === idx) {
          input.setAttribute('aria-activedescendant', el.id || '');
          el.scrollIntoView({ block: 'nearest' });
        }
      });
      activeIndex = idx;
    }

    input.addEventListener('input', onInput);
    input.addEventListener('focus', function () {
      if (!input.value.trim()) showPopular();
      else openPanel();
    });

    input.addEventListener('keydown', function (e) {
      var list = items();
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        if (panel.hidden) { onInput(); return; }
        setActive(Math.min(activeIndex + 1, list.length - 1));
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        setActive(Math.max(activeIndex - 1, 0));
      } else if (e.key === 'Enter') {
        if (activeIndex > -1 && list[activeIndex]) {
          e.preventDefault();
          list[activeIndex].click();
        }
        // else let the form submit normally
      } else if (e.key === 'Escape') {
        closePanel();
        input.blur();
      }
    });

    // Popular search chips fill the input and trigger a search.
    if (popularBox) {
      popularBox.addEventListener('click', function (e) {
        var chip = e.target.closest('[data-popular-term]');
        if (!chip) return;
        e.preventDefault();
        input.value = chip.getAttribute('data-popular-term');
        input.focus();
        onInput();
      });
    }

    // Scope outside-click to the form: root is the whole search section,
    // so clicks in the results grid or page whitespace never counted as outside.
    var form = input.closest('form') || root;
    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) closePanel();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-predictive-search]').forEach(init);
  });
})();
